/* eslint-disable */

import Globe from './Globe.js'
import * as THREE from 'three'
import BrightnessContrastShader from './Shaders/BrightnessContrast.js'
import ColorCorrectionShader from './Shaders/ColorCorrection.js'
import HorizontalBlurShader from './Shaders/HorizontalBlur.js'
import VerticalBlurShader from './Shaders/VerticalBlur.js'
import OverlayShader from './Shaders/Overlay.js'
import TilesShader from './Shaders/Tiles.js'
import EventEmitter from './EventEmitter.js'
import RadialGradients from './RadialGradients.js'
import Sections from './Sections.js'

import ShaderPass from './EffectComposer/ShaderPass.js'
import EffectComposer from './EffectComposer'
import RenderPass from './EffectComposer/RenderPass.js'


class Background extends EventEmitter
{
    /**
     * Constructor
     */
    constructor(options = {})
    {
        super(options)

        // Options
        this.$container = typeof options.$container !== 'undefined' ? options.$container : null
        this.autoResize = typeof options.autoResize !== 'undefined' ? options.autoResize : true
        this.autoRAF = typeof options.autoRAF !== 'undefined' ? options.autoRAF : true
        this.POICoordinates = typeof options.POICoordinates !== 'undefined' ? options.POICoordinates : []
        this.globeRotation = typeof options.globeRotation !== 'undefined' ? options.globeRotation : []
        this.cameraPosition = typeof options.cameraPosition !== 'undefined' ? options.cameraPosition : []
        this.mapMaskImage = typeof options.mapMaskImage !== 'undefined' ? options.mapMaskImage : ''
        this.filters = typeof options.filters !== 'undefined' ? options.filters : []
        this.cameraDebug = typeof options.cameraDebug !== 'undefined' ? options.cameraDebug : false
        this.isMobile = typeof options.isMobile !== 'undefined' ? options.isMobile : false
        this.sections = typeof options.sections !== 'undefined' ? options.sections : false

        // Animation
        this.animation = {}
        this.animation.targets = {}
        this.animation.targets.position_x = 0.25
        this.animation.targets.rotation_y = 0
        this.animation.targets.focalOffset = - 0.65
        this.animation.targets.overlayAlpha = 0

        window.setTimeout(() =>
        {
            this.animation.targets.position_x = 0.4
        }, 1500)

        this.scrollPos = 0

        // Tiles effect
        this.tilesEffect = {}
        this.tilesEffect.values = { x: 0.5, y: 0.5 }
        this.tilesEffect.smoothValues = { x: 0.5, y: 0.5 }

        // Set up
        this.setRAF()
        this.setRenderer()
        this.setEnvironment()
        this.setSections()
        this.setComposer()
        this.setGlobe()
        this.setRadialGradients()
        this.setResize()
    }

    /**
     * Set Renderer
     */
    setRenderer()
    {
        this.renderer = new THREE.WebGLRenderer({ preserveDrawingBuffer: true })
        this.renderer.autoClear = false
        this.$element = this.renderer.domElement
        this.$container.appendChild(this.$element)
    }

    /**
     * Set composer
     */
    setComposer()
    {
        // Composer
        this.composer = new EffectComposer(this.renderer)

        // Passes
        this.passes = {}
        this.passesCount = 0
        this.lastPass = null

        // First render pass
        this.passes.firstRender = new RenderPass(this.scene, this.camera)
        this.composer.addPass(this.passes.firstRender)

        // Second render
        this.passes.secondRender = new RenderPass(this.sections.scene, this.sections.camera)
        this.passes.secondRender.clear = false
        this.composer.addPass(this.passes.secondRender)
        this.passesCount++

        // Blur
        if(this.filters.indexOf('blur') !== -1)
        {
            this.focal = new THREE.Vector3(0.5, 0.5, 2)

            this.passes.horizontalBlur = new ShaderPass(HorizontalBlurShader)
            this.passes.horizontalBlur.enabled = true
            this.passes.horizontalBlur.renderToScreen = false
            this.passes.horizontalBlur.uniforms.h.value = 1 / window.innerHeight
            this.passes.horizontalBlur.uniforms.focal.value = this.focal
            this.passes.horizontalBlur.uniforms.focalIntensity.value = 2
            this.passes.horizontalBlur.uniforms.focalOffset.value = 0.65
            this.composer.addPass(this.passes.horizontalBlur)

            this.passes.verticalBlur = new ShaderPass(VerticalBlurShader)
            this.passes.verticalBlur.enabled = true
            this.passes.verticalBlur.renderToScreen = false
            this.passes.verticalBlur.uniforms.v.value = 1 / window.innerWidth
            this.passes.verticalBlur.uniforms.focal.value = this.focal
            this.passes.verticalBlur.uniforms.focalIntensity.value = 2
            this.passes.verticalBlur.uniforms.focalOffset.value = 0.65
            this.composer.addPass(this.passes.verticalBlur)

            this.lastPass = this.passes.verticalBlur

            this.passesCount++
        }

        // Tiles
        if(!this.isMobile)
        {
            this.passes.tiles = new ShaderPass(TilesShader)
            this.passes.tiles.enabled = true
            this.passes.tiles.renderToScreen = false
            this.passes.tiles.uniforms.uViewportSize.value.x = window.innerWidth
            this.passes.tiles.uniforms.uViewportSize.value.y = window.innerHeight
            this.composer.addPass(this.passes.tiles)
        }

        // Overlay
        this.passes.overlay = new ShaderPass(OverlayShader)
        this.passes.overlay.enabled = true
        this.passes.overlay.renderToScreen = false
        this.passes.overlay.uniforms.uColor.value = new THREE.Vector4(0.01176470588, 0, 0.06274509804, 1)
        this.composer.addPass(this.passes.overlay)
        this.passesCount++
        this.lastPass = this.passes.overlay

        // this.colorCorrection = new ShaderPass(ColorCorrectionShader)
        // this.colorCorrection.enabled = true
        // this.colorCorrection.renderToScreen = false
        // this.colorCorrection.uniforms.powRGB.value = new THREE.Vector3(1, 1, 0.1)
        // this.colorCorrection.uniforms.mulRGB.value = new THREE.Vector3(1, 1, 1)
        // this.composer.addPass(this.colorCorrection)

        // this.brightnessContrast = new ShaderPass(BrightnessContrastShader)
        // this.brightnessContrast.enabled = true
        // this.brightnessContrast.renderToScreen = true
        // this.brightnessContrast.uniforms.brightness.value = 0.05
        // this.brightnessContrast.uniforms.contrast.value = 0.1
        // this.composer.addPass(this.brightnessContrast)

        // Render last pass to screen
        if(this.lastPass)
        {
            this.lastPass.renderToScreen = true
        }
    }

    /**
     * Set Sections
     */
    setSections()
    {
        this.sections = new Sections({
            time: this.time,
            content: this.sections
        });
        // this.sections.setLogosVisible(this._logosVisible)
    }

    /**
     * Set Environment
     */
    setEnvironment()
    {
        // Scene
        this.scene = new THREE.Scene()
        this.scene.background = new THREE.Color(0x030010);

        // Camera container
        this.cameraContainer = new THREE.Object3D()
        this.scene.add(this.cameraContainer)

        // Camera
        this.camera = new THREE.PerspectiveCamera(90, window.innerWidth / window.innerHeight, 0.001, 1000)
        this.camera.position.set(this.cameraPosition[0], this.cameraPosition[1], this.cameraPosition[2])
        this.camera.lookAt(new THREE.Vector3(0, 1, 0))
        this.cameraContainer.add(this.camera)

        // Orbit controls
        if(this.cameraDebug)
        {
            this.orbitControls = new OrbitControls(this.camera, this.$element)
            this.orbitControls.target.y = 0.7
            this.orbitControls.zoomSpeed = 0.1
            this.orbitControls.minDistance = 0.6
            this.orbitControls.maxDistance = 2.2
        }
    }

    /**
     * Set Globe
     */
    setGlobe()
    {
        // Mover
        this.globeMover = new THREE.Object3D()
        this.globeMover.position.x = 0.25
        this.globeMover.rotation.y = 0
        this.scene.add(this.globeMover)

        // Globe
        this.globe = new Globe({
            time: this.time,
            camera: this.camera,
            POICoordinates: this.POICoordinates,
            mapMaskImage: this.mapMaskImage
        })
        this.globe.container.rotation.x = this.globeRotation[0]
        this.globe.container.rotation.y = this.globeRotation[1]
        this.globe.container.rotation.z = this.globeRotation[2]

        this.globe.on('ready', () =>
        {
            this.trigger('ready')
        })

        this.globeMover.add(this.globe.container)

        // // Debug
        // const inputChangeCallback = () =>
        // {
        //     this.globe.container.rotation.x = $inputX.value
        //     this.globe.container.rotation.y = $inputY.value
        //     this.globe.container.rotation.z = $inputZ.value
        // }

        // const $inputX = document.createElement('input')
        // $inputX.type = 'range'
        // $inputX.style.position = 'absolute'
        // $inputX.style.top = '0px'
        // $inputX.style.left = '0px'
        // $inputX.style.zIndex = 100
        // $inputX.min = 0
        // $inputX.max = Math.PI * 2
        // $inputX.step = 0.01
        // $inputX.value = 0
        // $inputX.addEventListener('change', inputChangeCallback)

        // document.body.appendChild($inputX)

        // const $inputY = document.createElement('input')
        // $inputY.type = 'range'
        // $inputY.style.position = 'absolute'
        // $inputY.style.top = '15px'
        // $inputY.style.left = '0px'
        // $inputY.style.zIndex = 100
        // $inputY.min = 0
        // $inputY.max = Math.PI * 2
        // $inputY.step = 0.01
        // $inputY.value = 0
        // $inputY.addEventListener('change', inputChangeCallback)

        // document.body.appendChild($inputY)

        // const $inputZ = document.createElement('input')
        // $inputZ.type = 'range'
        // $inputZ.style.position = 'absolute'
        // $inputZ.style.top = '30px'
        // $inputZ.style.left = '0px'
        // $inputZ.style.zIndex = 100
        // $inputZ.min = 0
        // $inputZ.max = Math.PI * 2
        // $inputZ.step = 0.01
        // $inputZ.value = 0
        // $inputZ.addEventListener('change', inputChangeCallback)

        // document.body.appendChild($inputZ)

        // $inputX.value = this.globe.container.rotation.x
        // $inputY.value = this.globe.container.rotation.y
        // $inputZ.value = this.globe.container.rotation.z

        window.globeMover = this.globeMover
        window.globe = this.globe.container
    }

    /**
     * Set Radial Gradients
     */
    setRadialGradients()
    {
        // Purple radial gradients
        this.radialGradientsPurple = new RadialGradients({ time: this.time, camera: this.camera, color: 0x100407 })
        // this.scene.add(this.radialGradientsPurple.container)
        this.radialGradientsPurple.container.renderOrder = 1

        // Gray radial gradients
        this.radialGradientsGray = new RadialGradients({ time: this.time, camera: this.camera, color: 0x121a26 })
        // this.scene.add(this.radialGradientsGray.container)
        this.radialGradientsGray.container.renderOrder = 2
    }

    /**
     * Set resize
     */
    setResize()
    {
        this.width  = 0
        this.height = 0

        if(this.autoResize)
        {
            window.addEventListener( 'resize', () =>
            {
                this.resize( this.$container.offsetWidth, this.$container.offsetHeight )
            } )

            this.resize( this.$container.offsetWidth, this.$container.offsetHeight )
        }
    }

    /*set logosVisible(visible)
    {
        if (this._logosVisible !== visible)
        {
            this._logosVisible = visible
            this.sections.setLogosVisible(this._logosVisible)
        }
    }*/

    /*get logosVisible()
    {
        return this._logosVisible
    }*/

    /**
     * Resize
     */
    resize(width, height)
    {
        this.width  = width
        this.height = height

        this.camera.aspect = this.width / this.height
        this.camera.updateProjectionMatrix()

        this.sections.resize(this.width, this.height)

        if(this.passes.tiles)
        {
            this.passes.tiles.uniforms.uViewportSize.value.x = this.width
            this.passes.tiles.uniforms.uViewportSize.value.y = this.height
        }

        this.renderer.setSize(this.width, this.height)
        this.composer.setSize(this.width, this.height)
    }

    /**
     * Set RAF
     */
    setRAF()
    {
        this.time = {}
        this.time.start = + new Date()
        this.time.current = 0
        this.time.elapsed = 1000 / 60
        this.time.delta = 16

        if(this.autoRAF)
        {
            const frame = () =>
            {
                window.requestAnimationFrame(() =>
                {
                    this.update()
                    frame()
                })
            }

            frame()
        }
    }

    /**
     * Set mouse
     */
    setMouse(x, y)
    {
        // Tiles effect
        this.tilesEffect.values.x = x + 0.5
        this.tilesEffect.values.y = 1 - y - 0.5
    }

    /**
     * Update
     */
    update()
    {
        // Time
        const current = + new Date() - this.time.start
        const elapsed = this.time.current - this.time.start
        const delta = current - this.time.current

        this.time.current = current
        this.time.elapsed = elapsed
        this.time.delta = delta

        // Camera
        if(this.cameraDebug)
        {
            this.orbitControls.update()
        }
        this.camera.position.y = 0.775 - this.scrollPos * 0.2

        // Radial gradients
        this.radialGradientsPurple.update()
        this.radialGradientsGray.update()

        // Tiles effect
        if(this.passes.tiles)
        {
            this.tilesEffect.smoothValues.x += (this.tilesEffect.values.x - this.tilesEffect.smoothValues.x) * 0.1
            this.tilesEffect.smoothValues.y += (this.tilesEffect.values.y - this.tilesEffect.smoothValues.y) * 0.1
            this.passes.tiles.uniforms.uCursorPosition.value.x = this.tilesEffect.smoothValues.x
            this.passes.tiles.uniforms.uCursorPosition.value.y = this.tilesEffect.smoothValues.y
        }

        // Animation
        this.globeMover.position.x += (this.animation.targets.position_x - this.globeMover.position.x) * 0.023
        this.globeMover.rotation.y += (this.animation.targets.rotation_y - this.globeMover.rotation.y) * 0.0275

        if(this.filters.indexOf('blur') !== -1)
        {
            this.passes.horizontalBlur.uniforms.focalOffset.value += (this.animation.targets.focalOffset - this.passes.horizontalBlur.uniforms.focalOffset.value) * 0.03
            this.passes.verticalBlur.uniforms.focalOffset.value += (this.animation.targets.focalOffset - this.passes.verticalBlur.uniforms.focalOffset.value) * 0.03
        }

        this.passes.overlay.uniforms.uColor.value.w += (this.animation.targets.overlayAlpha - this.passes.overlay.uniforms.uColor.value.w) * 0.02

        // Globe
        this.globe.update()

        // Sections
        this.sections.scrollPos = this.scrollPos
        this.sections.update()

        // Render
        if(this.passesCount === 0)
        {
            this.renderer.render(this.scene, this.camera)
        }
        else
        {
            this.composer.render()
        }

        this.renderer.render(this.sections.scene, this.sections.camera)
    }
}

export default Background



// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/index.js